import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { ALLERGEN_QUERY } from '../graphql/queries'
import { FETCH_ALLERGEN } from '../redux/action-types'
import { cleanupFetchAllergen } from '../redux/actions'

const useAllergenQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchAllergen)

  const { isFetchLoading, fetchError, data } = useSelector(
    store => store.allergens.allergen,
  )

  const refetch = useCallback(
    id => apolloService.query(ALLERGEN_QUERY, { id }, dispatch, FETCH_ALLERGEN),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading: isFetchLoading, error: fetchError, data, refetch }
}

export default useAllergenQuery
